import React, { useEffect } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Lottie from 'lottie-react';
import { LoadingSpinnerAnimation } from 'assets/animations';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import SidePanel from 'components/side-panel/SidePanel';
import { useLazyGetInvoiceByIdV2Query } from '../api';
import InvoiceUrlShare from './InvoiceUrlShare';
import { VoidFn } from 'types/baseTypes';

interface InvoiceOutletContext {
  handleSidePanelClose?: VoidFn;
  resetInvoicesQuery?: VoidFn;
}

const ShareUrlPanel: React.FC = () => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const { handleSidePanelClose } = useOutletContext<InvoiceOutletContext>() ?? {};
  const { invoiceId, rootInvoiceId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Get the selected amount and tracking response from navigation state
  const selectedAmount = location.state?.selectedAmount;
  const trackingResponse = location.state?.trackingResponse;

  const [getInvoiceByIdQuery, getInvoiceByIdResponse] = useLazyGetInvoiceByIdV2Query();
  const {
    data: invoiceDataResponse,
    isSuccess: invoiceDataSuccess,
    isFetching: fetchingInvoiceData
  } = getInvoiceByIdResponse;
  const invoiceData = invoiceDataResponse?.invoice;

  useEffect(() => {
    if (invoiceId || rootInvoiceId)
      getInvoiceByIdQuery({ invoiceId: invoiceId ? invoiceId : rootInvoiceId, teamId: currentTeam?.id });
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <SidePanel isOpen={true} onClose={handleSidePanelClose} shouldAnimate={location?.state?.shouldAnimate}>
      <div className="h-full w-96 px-[26px] pt-[30px]">
        {fetchingInvoiceData ? (
          <div className="flex h-full w-full items-center justify-center">
            <Lottie className="h-28 w-28" animationData={LoadingSpinnerAnimation} loop={true} />
          </div>
        ) : (
          invoiceDataSuccess && (
            <InvoiceUrlShare
              invoiceData={invoiceData}
              onBack={handleBackClick}
              selectedAmount={selectedAmount}
              trackingResponse={trackingResponse}
            />
          )
        )}
      </div>
    </SidePanel>
  );
};

export default ShareUrlPanel;
